<script lang="ts">
  import { Toggle } from 'bits-ui';

  interface Props {
    word: string;
    points: number;
    duplicate?: boolean;
    /** Makes the chip a toggle, for example to show the word on the post-match board. */
    onToggle?: (() => void) | undefined;
    /** The toggle's pressed state; only meaningful with `onToggle`. */
    pressed?: boolean;
  }
  let { word, points, duplicate = false, onToggle = undefined, pressed = false }: Props = $props();
</script>

<!-- Bits renders the toggle, so its chip rules are global like the other Bits-backed ui controls. -->
{#if onToggle}
  <Toggle.Root class={['chip', 'chip-toggle', duplicate && 'dup']} {pressed} onPressedChange={onToggle}
    >{word} <b>{points}</b></Toggle.Root
  >
{:else}
  <span class={['chip', duplicate && 'dup']}>{word} <b>{points}</b></span>
{/if}

<style>
  :global(.chip) {
    background: var(--theme-surface);
    border: var(--theme-card-border);
    color: var(--theme-surface-text);
    border-radius: var(--theme-chip-radius);
    padding: 4px 10px;
    font-size: var(--theme-word-chip-font-size);
    font-weight: var(--theme-word-chip-font-weight);
    animation: var(--theme-enter-animation);
    text-transform: lowercase;
    white-space: nowrap;
  }
  :global(.chip b) {
    color: var(--theme-accent);
    margin-left: 5px;
    font-weight: var(--theme-word-chip-score-weight);
  }
  :global(.chip.dup) {
    border-style: dashed;
  }
  :global(.chip-toggle) {
    position: relative;
    font-family: inherit;
    line-height: inherit;
    cursor: pointer;
  }
  /* Extends the hit area toward a 44px target without changing the chip's drawn size or spacing. */
  :global(.chip-toggle::after) {
    content: '';
    position: absolute;
    inset: -8px -4px;
  }
  :global(.chip-toggle[data-state='on']) {
    background: var(--theme-selected);
    color: var(--theme-selected-text);
  }
  :global(.chip-toggle[data-state='on'] b) {
    color: inherit;
  }
</style>
